import styled from 'styled-components';

import { COLORS } from '~/src/common/theme';

import Button from '../../Button';

export const StyledInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 17px;

  border: 1px solid ${COLORS.NEUTRAL_STROKE};
  background-color: ${COLORS.NEUTRAL_WHITE};
  border-radius: 4px;
  outline: none;

  transition: border 200ms ease 0s;

  &:disabled {
    cursor: not-allowed;
  }

  &:required {
    border: 1px solid ${COLORS.NEUTRAL_NOTIFICATION};
  }

  &:focus {
    border-color: ${COLORS.ACTION_DEFAULT};
    border-width: 2px;
  }

  /* Ne pas mettre moins de 16px pour éviter le zoom iOS mobile */
  font-size: 16px;
`;

export const HideTextButton = styled(Button).attrs(() => ({
  tabIndex: -1,
}))`
  position: absolute;
  bottom: 1px;
  color: ${COLORS.ACTION_DEFAULT};
  transition-property: right;
  transition-duration: 0.3s;

  span {
    font-size: 20px;
  }
`;
